import type { LendingVaultMap } from "@stepfinance/lending/src/lib/types";
import { useQuery } from "@tanstack/react-query";

import { STEP_API_ENDPOINT } from "../../utils/swr";
import { fetchJSONFromUrl } from "../../utils/utils";
import { queryConfig } from "./queryConfig";

export function useLendingVaultsQuery() {
  return useQuery(["lending", "vaults"], fetchLendingVaults, {
    ...queryConfig,
  });
}

async function fetchLendingVaults(): Promise<LendingVaultMap> {
  return await fetchJSONFromUrl(`${STEP_API_ENDPOINT}/v1/integration/lending`);
}
